export default "__VITE_ASSET__8403e97d__"